import React from 'react';

const Container = ({ children, className = '' }) => {
    return (
        <div className={`container px-6 mx-auto relative z-10 ${className}`}>
            {children}
        </div>
    );
};

export default Container;
